import { Menu } from 'antd';
import React from 'react';
// import Icon, { HomeFilled } from '@ant-design/icons';
import '../../view/antd/index.css';

const Sidebar = ({ filteredReports, getCurrentReport }) => {
  function generateNavLinks() {
    const reportsLinks =
      filteredReports &&
      filteredReports
        .sort((a, b) => a.sequence - b.sequence)
        .map((report, i) => {
          return {
            key: report.name,
            label: report.name,
            icon:
              report.icon && !report.icon.includes('-')
                ? React.createElement(report.icon)
                : '',
          };
        });
    return reportsLinks;
  }

  const sidemenuItems = generateNavLinks();

  const handleClick = (path) => {
    // console.log('path', path.key);
    const curReport = filteredReports.find((e) => e.name === path.key);

    curReport.reportTag === 'databaseEdit'
      ? getCurrentReport({ name: 'updateDb' })
      : getCurrentReport(curReport);
  };
  // console.log('sidemenuItems', sidemenuItems);
  return (
    <Menu
      theme="dark"
      mode="inline"
      items={sidemenuItems}
      onClick={handleClick}
    />
  );
};

export default Sidebar;
